export default __webpack_public_path__ + "static/media/picture.973c5dda.svg";